import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { variants } from "Login/TwoFA/constants";

const usePrefectTwoFA = () => {
  usePostTwoFactorAuth({
    postData: !window.data.loginLevel ? {} : false,
    variant: variants.signupList,
  });
};

export default usePrefectTwoFA;
